import { Button, Checkbox, FormControlLabel, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, useMemo, useCallback, memo } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../../request/Postrequest";
import {
  DELETE_TIMESHEET_JOBS,
  FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT
} from "../../../../constant/Apipath";
import { LoadingButton } from "@mui/lab";
import Loader from "../../../../common/Loader";
import DeletConfirmModal from "../../promptModal/DeletConfirmModal";
import { VIEW } from "./ClientTimesheetManualComponent";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";
import { BIGrey } from "../../../../assets/helpers";

function SelectJobsManual({ setView, setSelectJobData, selectedJobData }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);

  const USER_ID = loginData?.userInformation?.UserId;
  const CLIENT_ID = selectedClientData?.ClientId;
  const CLIENT_COLOR = selectedClientData?.AccentColor || "#000000";
  const CLIENT_EMPLOYEE_ID = selectedClientData?.ClientEmployeeId;
  const TOKEN = loginData?.accessToken;

  const [isLoading, setIsLoading] = useState(false);
  const [deleteState, setDeleteState] = useState({
    confirmModal: false,
    loading: false,
    currentId: null,
    dataObj: null
  });
  const [jobs, setJobs] = useState([]);
  const [location, setLocation] = useState({ latitude: 0, longitude: 0 });
  const [sortByNearby, setSortByNearby] = useState(false);

  const {
    TEXT_GEOLOCATION_NOT_SUPPORTED,
    TEXT_LOCATION_ACCESS_REQUIRED,
    TEXT_UNABLE_TO_ACCESS_LOCATION,
    TEXT_SELECT_JOB_ACTIVITIES,
    TEXT_SORT_BY,
    TEXT_NEAR_BY,
    TEXT_RECENT,
    BUTTON_NEXT,
    TEXT_NO_JOBS_FOUND
  } = ClientEnglishFallback?.SelectJobsManual(multiLanguageData?.SelectJobsManual || {});

  useEffect(() => {
    fetchLocation();
    fetchJobsAndActivities();
  }, [sortByNearby]);

  const mapSelectedStatus = useCallback(
    (jobsData) => {
      return jobsData.map((job) => {
        const jobSelection = selectedJobData.find((item) => item.clientJobId === job.clientJobId);
        const isJobSelected = jobSelection?.isSelected === true;

        if (job.clientJobActivitiesList.length === 0) {
          return { ...job, isSelected: isJobSelected };
        }

        const updatedActivities = job.clientJobActivitiesList.map((activity) => {
          const activitySelection = selectedJobData.find(
            (item) =>
              item.id === activity.id &&
              item.clientJobId === activity.clientJobId
          );
          return {
            ...activity,
            isSelected: activitySelection?.isSelected === true
          };
        });

        return {
          ...job,
          isSelected: isJobSelected,
          clientJobActivitiesList: updatedActivities
        };
      });
    },
    [selectedJobData]
  );

  const fetchLocation = async () => {
    if (!navigator.permissions || !navigator.geolocation) {
      console.warn("fetchLocation-> Geolocation or Permissions API not supported");
      return;
    }

    try {
      const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
      if (permissionStatus.state === "granted") {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          },
          (err) => {
            console.warn("fetchLocation-> Location access denied or unavailable", err);
          }
        );
      }
    } catch (err) {
      console.error("fetchLocation-> Error accessing geolocation:", err);
    }
  };

  const fetchJobsAndActivities = async () => {
    setIsLoading(true);

    let userLatitude = 0;
    let userLongitude = 0;

    if (sortByNearby) {
      if (location?.latitude && location?.longitude) {
        userLatitude = location.latitude;
        userLongitude = location.longitude;
      } else {
        if (!navigator.permissions || !navigator.geolocation) {
          alert(TEXT_GEOLOCATION_NOT_SUPPORTED);
          setIsLoading(false);
          return;
        }

        try {
          const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

          if (permissionStatus.state === "denied") {
            alert(TEXT_LOCATION_ACCESS_REQUIRED);
            setIsLoading(false);
            return;
          }

          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });

          userLatitude = position.coords.latitude;
          userLongitude = position.coords.longitude;

          setLocation({
            latitude: userLatitude,
            longitude: userLongitude
          });
        } catch (error) {
          alert(TEXT_UNABLE_TO_ACCESS_LOCATION);
          setIsLoading(false);
          return;
        }
      }
    }

    try {
      const payload = {
        PageNumber: 1,
        NrRowsPerPage: 100,
        UserLatitude: userLatitude,
        UserLongitude: userLongitude,
        ClientId: CLIENT_ID,
        ClientEmployeeId: CLIENT_EMPLOYEE_ID,
        SortBy: sortByNearby ? 1 : 2
      };

      const response = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT, payload, TOKEN);

      const mappedData = mapSelectedStatus(response.data.data || []);
      setJobs(mappedData);
    } catch (error) {
      console.error("fetchJobsAndActivities-> Error fetching jobs and activities:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleJobClick = useCallback((job, index) => {
    // Handle deletion case
    if (job?.isAlerady && job?.timesheetJobId && job.clientJobActivitiesList.length === 0) {
      setDeleteState({
        confirmModal: true,
        currentId: job?.timesheetJobId,
        dataObj: {
          job: { ...job, isAlerady: false, timesheetJobId: 0 },
          jindex: index,
          aindex: null
        },
        loading: false
      });
      return;
    }

    setJobs((prevJobs) =>
      prevJobs.map((item, i) => (i === index ? { ...item, isSelected: !item.isSelected } : item))
    );
  }, []);

  const handleActivityClick = useCallback((job, jindex, aindex) => {
    const activity = job.clientJobActivitiesList[aindex];

    if (activity?.isAlerady && activity?.timesheetJobId) {
      setDeleteState({
        confirmModal: true,
        currentId: activity?.timesheetJobId,
        dataObj: {
          job: { ...activity, isAlerady: false, timesheetJobId: 0 },
          jindex: jindex,
          aindex: aindex
        },
        loading: false
      });
      return;
    }

    setJobs((prevJobs) => {
      return prevJobs.map((item, i) => {
        if (i === jindex) {
          const updatedActivities = item.clientJobActivitiesList.map((act, actIndex) =>
            actIndex === aindex ? { ...act, isSelected: !act.isSelected } : act
          );

          const anyActivitySelected = updatedActivities.some(
            (act) => act.isSelected || act.isAlerady
          );

          return {
            ...item,
            isSelected: anyActivitySelected,
            clientJobActivitiesList: updatedActivities
          };
        }
        return item;
      });
    });
  }, []);

  const handleJobDelete = async () => {
    if (!deleteState.currentId) return;

    try {
      setDeleteState((prev) => ({ ...prev, loading: true }));

      const deleteObj = {
        UserId: USER_ID,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [{ Id: deleteState.currentId }]
      };

      const res = await Postrequestcall(DELETE_TIMESHEET_JOBS, deleteObj, TOKEN);

      if (res.status === 201) {
        setJobs((prevJobs) => {
          return prevJobs.map((job, jIndex) => {
            if (jIndex === deleteState.dataObj.jindex) {
              if (deleteState.dataObj.aindex === null) {
                return {
                  ...job,
                  isSelected: false,
                  isAlerady: false,
                  timesheetJobId: 0
                };
              } else {
                const updatedActivities = job.clientJobActivitiesList.map((act, aIndex) => {
                  if (aIndex === deleteState.dataObj.aindex) {
                    return {
                      ...act,
                      isSelected: false,
                      isAlerady: false,
                      timesheetJobId: 0
                    };
                  }
                  return act;
                });

                const anyActivitySelected = updatedActivities.some(
                  (act) => act.isSelected || act.isAlerady
                );

                return {
                  ...job,
                  clientJobActivitiesList: updatedActivities,
                  isSelected: anyActivitySelected
                };
              }
            }
            return job;
          });
        });
      }
    } catch (error) {
      console.error("handleJobDelete-> Error deleting job:", error);
    } finally {
      resetDeleteState();
    }
  };

  const resetDeleteState = useCallback(() => {
    setDeleteState({
      confirmModal: false,
      loading: false,
      currentId: null,
      dataObj: null
    });
  }, []);

  const formatData = useCallback(() => {
    try {
      const selected = [];

      jobs.forEach((job) => {
        if (job.clientJobActivitiesList.length === 0 && job.isSelected) {
          selected.push({
            ...job,
            selectionType: "job"
          });
        }

        job.clientJobActivitiesList.forEach((activity) => {
          if (activity.isSelected) {
            selected.push({
              ...activity,
              selectionType: "activity",
              clientJobId: job.clientJobId,
              clientJobName: job.clientJobName,
              clientJobCode: job.clientJobCode
            });
          }
        });
      });

      const updatedJobData = selected.map((selectedItem) => {
        const existing = selectedJobData.find((item) => {
          if (selectedItem.selectionType === "activity") {
            return (
              item.id === selectedItem.id &&
              item.clientJobId === selectedItem.clientJobId
            );
          } else {
            return item.clientJobId === selectedItem.clientJobId && !item.id;
          }
        });

        return (
          existing || {
            ...selectedItem,
            isSelected: true,
            hours: "",
            mileage: "",
            mileageUnit: "km",
            notes: "",
            activityId: selectedItem.id,
            id: selectedItem.id || 0,
            timesheetJobId: selectedItem.timesheetJobId || 0,
          }
        );
      });

      setSelectJobData(updatedJobData);
      setView(VIEW.LISTING);
    } catch (error) {
      console.error("formatData-> Error formatting data:", error);
    }
  }, [jobs, selectedJobData, setSelectJobData, setView]);


  const hasSelectedJobs = useMemo(() => {
    return jobs.some((job) => job.isSelected);
  }, [jobs]);

  return (
    <>
      <DeletConfirmModal
        isOpen={deleteState.confirmModal}
        loading={deleteState.loading}
        onConfirm={handleJobDelete}
        onClose={resetDeleteState}
      />

      {isLoading ? (
        <Loader />
      ) : (
        <Grid container spacing={1}>
          <Grid size={12}>
            <Stack direction="row" sx={{ justifyContent: "space-between" }}>
              <Typography>{TEXT_SELECT_JOB_ACTIVITIES}</Typography>
              <Stack sx={{ gap: 0.5 }} direction="row" >
                <Typography>{TEXT_SORT_BY}</Typography>
                <Typography
                  onClick={() => setSortByNearby((prev) => !prev)}
                  sx={{ color: CLIENT_COLOR, cursor: "pointer" }}>
                  {sortByNearby ? TEXT_NEAR_BY : TEXT_RECENT}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            sx={{
              maxHeight: "300px",
              overflow: "auto"
            }}
            size={12}>
            <Stack spacing={1}>
              {jobs?.length === 0 && (
                <Stack sx={{ justifyContent: "center", alignItems: "center", height: "100px", width: "100%" }}>
                  <Typography sx={{ color: BIGrey }}>{TEXT_NO_JOBS_FOUND}</Typography>
                </Stack>
              )}
              {jobs.map((job, index) => (
                <Listing
                  key={`job-${job.clientJobId || index}`}
                  jindex={index}
                  job={job}
                  CLIENT_COLOR={CLIENT_COLOR}
                  handleJobClick={handleJobClick}
                  handleActivityClick={handleActivityClick}
                />
              ))}
            </Stack>
          </Grid>

          <Grid size={12}>
            <LoadingButton
              disabled={!hasSelectedJobs}
              onClick={formatData}
              loadingPosition="start"
              startIcon={<></>}
              fullWidth
              sx={{
                bgcolor: !hasSelectedJobs ? "#e4e4e4" : CLIENT_COLOR,
                color: "white",
                textTransform: "none"
              }}>
              {BUTTON_NEXT}
            </LoadingButton>
          </Grid>
        </Grid>
      )}
    </>
  );
}

const Listing = memo(({ job, jindex, CLIENT_COLOR, handleJobClick, handleActivityClick }) => {
  const hasActivities = job.clientJobActivitiesList?.length > 0;

  return (
    <Stack
      onClick={() => {
        if (!hasActivities) {
          handleJobClick(job, jindex);
        }
      }}
      sx={{
        border: "1px solid #e4e4e4",
        borderColor: !hasActivities ? "#e4e4e4" : "transparent",
        borderRadius: "5px",
        cursor: !hasActivities ? "pointer" : "default"
      }}
      spacing={1}>
      <Stack direction="row" sx={{ alignItems: "center" }}>
        {!hasActivities && (
          <>
            <Checkbox
              checked={!!job.isSelected}
              sx={{
                "&.Mui-checked": {
                  color: CLIENT_COLOR
                }
              }}
            />
            <Typography sx={{ fontWeight: 600 }}>
              {job.clientJobCode} - {job.clientJobName}
            </Typography>
          </>
        )}
      </Stack>

      {hasActivities && (
        <Stack sx={{ gap: 1 }} >
          <Typography>
            {job.clientJobCode} - {job.clientJobName}
          </Typography>
          <Stack sx={{ paddingLeft: "15px", gap: 1 }}>
            {job.clientJobActivitiesList.map((act, aindex) => (
              <Stack
                key={`${job.clientJobId}-${act.id || aindex}`}
                direction="row"
                onClick={(e) => {
                  handleActivityClick(job, jindex, aindex);
                }}
                sx={{
                  border: "1px solid #e4e4e4",
                  borderRadius: "5px",
                  cursor: "pointer",
                  alignItems: "center"
                }}>
                <Checkbox
                  checked={!!(act.isSelected || act.isAlerady)}
                  sx={{
                    "&.Mui-checked": {
                      color: CLIENT_COLOR
                    }
                  }}
                />
                <Typography sx={{ fontWeight: 600 }}>
                  {act.labourActivityCode} - {act.labourActivityName}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
});

export default SelectJobsManual;

